import { library, dom, config } from "@fortawesome/fontawesome-svg-core";
import {
  faFacebookF,
  faTwitter,
  faLinkedin,
  faYoutube,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import {    
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faChevronUp,  
  faFilter,
  faDownload,
  faPhone,
  faPhoneAlt
} from "@fortawesome/free-solid-svg-icons";

config.searchPseudoElements = true;
/* 
To use pseudo, requires declaration to look like this:
el::before{ 
  display: none;
  font-family: "Font Awesome 5 Solid";
  font-weight: 900;
  content: "\f078";
}
*/

class FontAwesomeIcons {
  constructor() {
    this.initialiseFontAweomse();
  }

  initialiseFontAweomse() {
    library.add(faFacebookF, faTwitter, faLinkedin, faYoutube, faInstagram, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faFilter, faDownload, faPhone, faPhoneAlt);
    dom.watch();
  }
}

export default FontAwesomeIcons;



// WEBPACK FOOTER //
// ./scripts/components/FontAwesomeIcons.js